import { createAction } from '@ngrx/store';

export const changeLegView = createAction('[TaskMgmt.LegView] Change Leg View');
